import React, { HTMLAttributes } from 'react'
import styled from '@emotion/styled'

export const StopPropagation = ({ onClick, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const { Layout } = StopPropagation
  const handleClick = (e: any) => {
    onClick?.(e)
    e.stopPropagation()
  }
  return <Layout onClick={handleClick} {...props} />
}
StopPropagation.Layout = styled.div`
  display: inline;
`
